import React from 'react';
import { useTranslation } from 'react-i18next';
import bg1 from '../assets/images/bg1.png';
import bg2 from '../assets/images/bg2.png';
import bg3 from '../assets/images/bg3.png';
import bg4 from '../assets/images/bg4.png';
import iconMilestoneTracking from '../assets/images/features-milestone-tracking.svg';
import iconRealtimeSupport from '../assets/images/features-real-time-support.svg';
import iconInteractiveActivities from '../assets/images/features-interactive-activities.svg';
import iconPsychologicalCognitive from '../assets/images/features-psychological-cognitive-guidance.svg';

interface Feature {
    icon: string;
    background: string;
    link: string;
}

const EducationalPrograms: React.FC = () => {
    const { t } = useTranslation();

    const featureData: Feature[] = [
        {
            icon: iconMilestoneTracking,
            background: bg1,
            link: "#milestone-tracking"
        },
        {
            icon: iconRealtimeSupport,
            background: bg2,
            link: "#realtime-support"
        },
        {
            icon: iconInteractiveActivities,
            background: bg3,
            link: "#interactive-activities"
        },
        {
            icon: iconPsychologicalCognitive,
            background: bg4,
            link: "#psychological-cognitive-guidance"
        }
    ];

    return (
        <div id="features" className="section-service-area service-area-v2">
            <div className="padding-global">
                <div className="container-large">
                    <div className="padding-section-large">
                        <div className="service-area-component">
                            {/* Section Header */}
                            <div className="service-area-top-content">
                                <div className="heading-wrapper">
                                    <h2 className="heading-style-h2">{t('educationalPrograms.heading')}</h2>
                                    <div className="line-color-blue" style={{width: '100%', height: '15px'}}></div>
                                </div>
                                <div className="padding-bottom padding-xsmall"></div>
                                <p className="text-size-small text-align-center">
                                    {t('educationalPrograms.subheading')}
                                </p>
                            </div>

                            <div className="padding-bottom padding-large"></div>

                            {/* Features Grid */}
                            <div className="services-area-collection-list-wrapper w-dyn-list">
                                <div role="list" className="services-area-collection-list educational-programs-grid w-dyn-items">
                                    {featureData.map((feature, index) => (
                                        <div
                                            key={index}
                                            role="listitem"
                                            className="services-area-collection-item educational-program-item w-dyn-item"
                                            data-w-id={`feature-${index}`}
                                        >
                                            <a href={feature.link} className="educational-program-link">
                                                <div
                                                    className="educational-program-card"
                                                    style={{
                                                        backgroundImage: `url(${feature.background})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        backgroundRepeat: 'no-repeat'
                                                    }}
                                                >
                                                    <div className="program-icon-wrapper">
                                                        <img
                                                            src={feature.icon}
                                                            loading="lazy"
                                                            alt={t(`educationalPrograms.items.${index}.title`)}
                                                            className="program-icon"
                                                        />
                                                    </div>
                                                    <div className="padding-bottom padding-xsmall"></div>
                                                    <h4 className="heading-style-h4">{t(`educationalPrograms.items.${index}.title`)}</h4>
                                                    <div className="padding-bottom padding-xxsmall"></div>
                                                    <p className="text-size-regular program-description">
                                                        {t(`educationalPrograms.items.${index}.description`)}
                                                    </p>
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EducationalPrograms;
